import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './component/ScrollToTop';
import Home from './pages/Home';
import Apartments from './pages/Apartments';
import Aboutus from './pages/Aboutus';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import WebsiteStructure from './component/WebsiteStructure';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import ApartmentDetail from './pages/ApartmentDetailPage';

function App() {
  return (
    <Router>

      <ScrollToTop />

      <Routes>
        <Route path="/" element={<WebsiteStructure />}>

          <Route index element={<Home />} />
          <Route path="/apartments" element={<Apartments />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/apartment/:id" element={<ApartmentDetail />} />

        </Route>
      </Routes>

    </Router>
  );
}

export default App;